import React, { useEffect, useRef, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import $ from 'jquery'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import PrefectureItem from "./prefectureItem.js"
import { popularPrefectures, otherPrefectures } from "../utils/prefectures"

const Destination = ({blok}) => {

  const { prefectures } = useStaticQuery(graphql`
  query {
    prefectures: allStoryblokEntry(filter: {field_component: {eq: "prefectureItem"}}) {
      edges {
        node {
          uuid
          name
          content
          field_component
          full_slug
        }
      }
    }
  } 
  `)
  // console.log(prefectures)

  const prefectureNameMap = prefectures.edges.reduce((acc, e) => {
    acc[e.node.name] = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content
    return acc
  }, {});
  // console.log(prefectureNameMap)

  const [prefecture, setPrefecture] = useState('Tokyo');

  const mapRef = useRef(null);

  useEffect(() => {
    window.jQuery = $
    if ($.japanMap === undefined) {
      require('../../static/jquery.japan-map.js')
    }

    $(mapRef.current).japanMap({
      width: 750,
      drawsBoxLine : false,
      hoverColor: '#f87171',
      showsPrefectureName: true,
      prefectureNameType: 'english',
      movesIslands: true,
      font: 'source-han-sans-japanese',
      fontSize : 11,
      fontColor: 'black',
      onSelect : function(data){
        setPrefecture(data.name);
        // console.log(data);
      }
    });

    return () => {
      $(mapRef.current).empty();
    }
  }, []);
  
  return (

    <section className="destinations-section max-w-screen-2xl mx-auto my-12">
      
      {/* Amny Kun bubble */}
      <div className="relative flex justify-center md:h-[50px]">
        <img className="md:absolute w-auto h-[250px] right-10" src="/img/47-prefectures.png" alt="Amny-kun" loading="lazy"/>
      </div>

      <h2 className="flex justify-center font-bold text-3xl md:text-4xl my-6 md:my-10">Destinations</h2>

      <div className="flex mx-4 flex-wrap">

          <div className="left-box w-full order-2 md:w-1/2 md:order-1">
        
            <PrefectureItem blok={prefectureNameMap[prefecture]} />
            
          </div>

          <div className="right-box w-full order-1 md:w-1/2 md:order-2 md:border-l flex flex-col items-start">
            <label className="ml-4 p-3 rounded-lg border border-gray-800">
              <img className="mr-2 inline" src="/icons/search-section-pin.svg" alt="prefecture" />
              <select name="prefecture" className="outline-none" value={prefecture} onChange={e => setPrefecture(e.target.value)}>
                {/* {
                  prefectures.edges.map(({ node }) => (
                    <option key={node.name} value={node.name}>{node.name}</option>
                  ))
                } */}
                {
                  popularPrefectures.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))
                }
                <option value="" disabled>------------</option>
                {
                  otherPrefectures.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))
                }
              </select>
            </label>
            <div id="japan-map" ref={mapRef} className="w-full overflow-x-auto"/>
          </div>
      </div>
      
    </section>

  )
}
  
export default Destination
